import { render, staticRenderFns } from "./NoteTopUpMobile.vue?vue&type=template&id=6cbbbb1d&scoped=true&"
import script from "./NoteTopUpMobile.vue?vue&type=script&lang=js&"
export * from "./NoteTopUpMobile.vue?vue&type=script&lang=js&"
import style0 from "./NoteTopUpMobile.vue?vue&type=style&index=0&id=6cbbbb1d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbbbb1d",
  null
  
)

export default component.exports